import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function ProtectedRoute({ children }) {
  const { isLoggedIn } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isLoggedIn) {
      // 현재 경로를 from 파라미터로 전달하여 로그인 후 돌아올 수 있도록 함
      navigate(`/login?from=${encodeURIComponent(location.pathname)}`)
    }
  }, [isLoggedIn, navigate, location.pathname])

  if (!isLoggedIn) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: 'calc(100vh - 80px)',
        color: '#666'
      }}>
        로그인 페이지로 이동 중...
      </div>
    )
  }

  return children
}